import type { CSSProperties } from 'react'
import DashStatCard from '../../components/ui/DashStatCard'
import StatusBadge from '../../components/ui/StatusBadge'
import DashIcon from '../../components/ui/DashIcon'

const virements = [
  { date: '14 mai 2026', ref: 'TX-PAY-08412', period: 'Semaine du 8–14 mai',     amount: '7,840.500 DT', status: 'paid' },
  { date: '07 mai 2026', ref: 'TX-PAY-08321', period: 'Semaine du 1–7 mai',      amount: '8,210.000 DT', status: 'paid' },
  { date: '30 avr 2026', ref: 'TX-PAY-08218', period: 'Semaine du 24–30 avr',    amount: '6,920.250 DT', status: 'paid' },
  { date: '23 avr 2026', ref: 'TX-PAY-08129', period: 'Semaine du 17–23 avr',    amount: '6,670.000 DT', status: 'paid' },
  { date: '19 mai 2026', ref: 'TX-PAY-08501', period: 'En cours · 12 colis',     amount: '12,840.000 DT',status: 'pending' },
]

const factures = [
  { month: 'Mai 2026',    amount: '2,436 DT', status: 'unpaid', note: 'À payer 31/05' },
  { month: 'Avril 2026',  amount: '2,184 DT', status: 'paid',   note: 'Payée 02/05' },
  { month: 'Mars 2026',   amount: '1,920 DT', status: 'paid',   note: 'Payée 31/03' },
  { month: 'Février 2026',amount: '1,840 DT', status: 'paid',   note: 'Payée 28/02' },
]

export default function ExpediteurPaiements() {
  return (
    <>
      <div className="page-head">
        <div className="ph-titles">
          <h1>Paiements</h1>
          <p>Vos COD collectés, virements et factures.</p>
        </div>
        <div className="ph-actions">
          <button className="btn btn-ghost"><DashIcon name="download" size={14} /> Relevé</button>
          <button className="btn btn-primary"><DashIcon name="card" size={14} /> Demander virement</button>
        </div>
      </div>

      <div className="detail-grid" style={{ '--detail-cols': '380px 1fr', gap: 18, marginBottom: 18 } as CSSProperties}>
        <div className="wallet-card">
          <div className="w-label">COD à recevoir</div>
          <div className="w-amount">12,840<sup>DT</sup></div>
          <div className="w-meta">
            <span>Prochain virement: <b style={{ color: '#fff' }}>Vendredi 19 mai</b></span>
          </div>
          <div className="w-actions">
            <button className="w-btn w-btn-primary"><DashIcon name="card" size={14} />Virer maintenant</button>
            <button className="w-btn"><DashIcon name="receipt" size={14} />Détails</button>
          </div>
        </div>

        <div className="stat-grid stat-grid-3">
          <DashStatCard label="Total ce mois"    value="48,720 DT"  trend="+18% vs avril"     icon="wallet" spark={[2000,2400,2800,3200,3800,4200,4800,5200,5800,6400,7200,8200]} />
          <DashStatCard label="Virements reçus"  value="4"          trend="29,640 DT"           icon="card" />
          <DashStatCard label="En cours"         value="12,840 DT"  trend="42 colis livrés"    icon="clock" />
          <DashStatCard label="Frais service"    value="2,436 DT"   trend="5% du COD"          icon="receipt" accent="dark" />
          <DashStatCard label="Délai moyen"      value="2.1 jrs"    trend="J+2 après livraison" icon="clock" />
          <DashStatCard label="Compte bancaire"  value="BIAT •••4821" trend="Virement automatique" icon="card" />
        </div>
      </div>

      <div className="detail-grid" style={{ '--detail-cols': '1.5fr 1fr', gap: 18 } as CSSProperties}>
        <div className="card" style={{ padding: 0 }}>
          <div style={{ padding: '18px 20px', borderBottom: '1px solid var(--line)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <h3>Historique des virements</h3>
              <p style={{ color: 'var(--muted)', fontSize: '.82rem', marginTop: 2 }}>4 virements ce mois · 29,640 DT</p>
            </div>
            <button className="btn btn-sm btn-ghost"><DashIcon name="download" size={14} /> CSV</button>
          </div>
          <div>
            {virements.map((r, i) => (
              <div key={i} className="invoice-row">
                <div className="inv-icon" style={r.status === 'pending' ? { background: 'var(--amber-50)', color: '#a06d12' } : undefined}>
                  <DashIcon name={r.status === 'paid' ? 'check' : 'clock'} size={18} />
                </div>
                <div className="inv-body">
                  <b>{r.period}</b>
                  <span>{r.ref} · {r.date}</span>
                </div>
                <StatusBadge status={r.status} />
                <span className="inv-amount">{r.amount}</span>
                <button className="btn btn-sm btn-ghost">PDF</button>
              </div>
            ))}
          </div>
        </div>

        <div className="card">
          <div className="card-head">
            <h3>Factures Door Deal</h3>
            <span style={{ fontSize: '.78rem', color: 'var(--muted)' }}>Frais de service 5%</span>
          </div>
          <div>
            {factures.map((r, i) => (
              <div key={i} style={{
                display: 'grid', gridTemplateColumns: '1fr auto auto', gap: 12, alignItems: 'center',
                padding: '14px 0', borderTop: i ? '1px solid var(--line)' : '0',
              }}>
                <div>
                  <b style={{ color: 'var(--navy-900)', fontSize: '.92rem' }}>Facture {r.month}</b>
                  <div style={{ color: 'var(--muted)', fontSize: '.78rem' }}>{r.note}</div>
                </div>
                <span className="mono" style={{ color: 'var(--navy-900)', fontWeight: 700, fontFamily: 'Space Grotesk' }}>{r.amount}</span>
                <StatusBadge status={r.status} />
              </div>
            ))}
          </div>
          <button className="btn btn-ghost" style={{ width: '100%', justifyContent: 'center', marginTop: 14 }}>
            Voir toutes les factures
          </button>
        </div>
      </div>
    </>
  )
}
